<script setup lang="ts">
import { computed } from 'vue';
import type { ToastEntry } from '@/composables/useToast';

const props = defineProps<{
    toast: ToastEntry;
}>();

const emit = defineEmits<{
    dismiss: [id: number];
}>();

const alertClass = computed(() => {
    switch (props.toast.severity) {
        case 'success':
            return 'alert-success';
        case 'warn':
            return 'alert-warning';
        case 'critical':
            return 'alert-danger';
        default:
            return 'alert-info';
    }
});
</script>

<template>
    <div
        class="alert toast-alert"
        :class="alertClass"
        role="status"
        aria-live="polite"
    >
        <button
            type="button"
            class="toast-button"
            @click="emit('dismiss', toast.id)"
        >
            <span class="toast-message">{{ toast.message }}</span>
        </button>
    </div>
</template>

<style scoped>
.toast-alert {
    position: relative;
    top: auto;
    left: auto;
    right: auto;
    z-index: auto;
    display: block;
    margin-bottom: 10px;
    width: 100%;
    padding: 14px 20px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
    text-align: left;
    border-width: 1px;
}

.toast-button {
    display: block;
    width: 100%;
    margin: 0;
    padding: 0;
    text-align: inherit;
    font: inherit;
    color: inherit;
    background: none;
    border: 0;
    box-shadow: none;
    cursor: pointer;
}

.toast-message {
    font-size: 14px;
    line-height: 1.4;
    color: inherit;
    white-space: normal;
    word-break: break-word;
}
</style>
